import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const SKFlagIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <circle cx="10" cy="10" r="8.88889" fill="#F2F0F2" />
      <mask
        id="mask0_sk_flag"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="18"
        height="18"
      >
        <circle cx="10" cy="10" r="8.88889" fill="#FCFCFC" />
      </mask>
      <g mask="url(#mask0_sk_flag)">
        <rect
          x="1.11111"
          y="1.11111"
          width="17.7778"
          height="17.7778"
          fill="#F2F0F2"
        />
        <rect
          x="1.11111"
          y="7.03704"
          width="17.7778"
          height="5.92593"
          fill="#0052B5"
        />
        <rect
          x="1.11111"
          y="12.96297"
          width="17.7778"
          height="5.92593"
          fill="#D90026"
        />
      </g>
      <path
        d="M4.7 4.7H9.3V10.1C9.3 12.7 7 14.1 7 14.1C7 14.1 4.7 12.7 4.7 10.1Z"
        fill="#F2F0F2"
      />
      <path
        d="M5.1 5.2H8.9V10C8.9 12.3 7 13.5 7 13.5C7 13.5 5.1 12.3 5.1 10Z"
        fill="#D90026"
      />
      <path
        d="M5.5 11.5C6.1 11 6.4 11 7 11.5C7.6 11 7.9 11 8.5 11.5V12.4H5.5Z"
        fill="#0052B5"
      />
      <rect x="6.7" y="6.2" width="0.6" height="5.6" fill="#F2F0F2" />
      <rect x="6.0" y="7.2" width="2.0" height="0.55" fill="#F2F0F2" />
      <rect x="5.7" y="8.75" width="2.6" height="0.55" fill="#F2F0F2" />
    </BaseIcon>
  );
};

SKFlagIcon.displayName = 'SKFlagIcon';
